import { t, ui } from '../i18n';
import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import {
  Drawer,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Divider,
  Box,
  Typography
} from '@mui/material';
import {
  Dashboard as DashboardIcon,
  AccountTree as BlocksIcon,
  SwapHoriz as TransactionIcon,
  Person as PersonIcon
} from '@mui/icons-material';

interface KULSSidebarProps {
  open: boolean;
  onClose: () => void;
}

const KULSSidebar: React.FC<KULSSidebarProps> = ({ open, onClose }) => {
  const navigate = useNavigate();
  const location = useLocation();

  const menuItems = [
    {
      text: 'Dashboard',
      icon: <DashboardIcon />,
      path: '/dashboard',
      color: '#1976d2'
    },
    {
      text: 'My Transactions',
      icon: <TransactionIcon />,
      path: '/transactions',
      color: '#f57c00'
    },
    {
      text: 'My Blocks',
      icon: <BlocksIcon />,
      path: '/blocks',
      color: '#4caf50'
    },
    {
      text: 'My Info',
      icon: <PersonIcon />,
      path: '/my-info',
      color: '#ff9800'
    }
  ];

  const handleNavigation = (path: string) => {
    navigate(path);
  };

  const drawerWidth = 240;

  return (
    <Drawer
      variant="persistent"
      anchor="left"
      open={open}
      sx={{
        width: drawerWidth,
        flexShrink: 0,
        '& .MuiDrawer-paper': {
          width: drawerWidth,
          boxSizing: 'border-box',
          top: '70px', // Header height
          height: 'calc(100vh - 70px)',
          backgroundColor: '#f8f9fa',
          borderRight: '1px solid #e0e0e0'
        },
      }}
    >
      <Box sx={{ overflow: 'auto' }}>
        {/* Organization Info */}
        <Box sx={{ p: 2, backgroundColor: '#1976d2', color: 'white' }}>
          <Typography variant="h6" sx={{ fontWeight: 'bold', mb: 0.5 }}>{t("KULS Organization")}</Typography>
          <Typography variant="body2" sx={{ opacity: 0.9, fontSize: '0.85rem', lineHeight: 1.3 }}>{t("KULS - Logistics Business Partner")}</Typography>
          <Typography variant="caption" sx={{ opacity: 0.8, fontSize: '0.75rem', display: 'block', mt: 0.5 }}>{t("EasyContainer • TMS • Yard Management")}</Typography>
        </Box>

        <Divider />

        {/* Navigation Menu */}
        <List sx={{ pt: 2 }}>
        {menuItems.map((item) => {
          const isSelected = location.pathname === item.path;
          return (
            <ListItem key={item.text} disablePadding sx={{ mb: 1, px: 1 }}>
              <ListItemButton
                selected={isSelected}
                onClick={() => handleNavigation(item.path)}
                sx={{
                  borderRadius: 2,
                  mx: 1,
                  '&.Mui-selected': {
                    backgroundColor: `${item.color}15`,
                    color: item.color,
                    '& .MuiListItemIcon-root': {
                      color: item.color,
                    },
                    '&:hover': {
                      backgroundColor: `${item.color}25`,
                    }
                  },
                  '&:hover': {
                    backgroundColor: '#f0f0f0',
                  }
                }}
              >
                <ListItemIcon
                  sx={{
                    color: isSelected ? item.color : 'inherit',
                    minWidth: 40
                  }}
                >
                  {item.icon}
                </ListItemIcon>
                <ListItemText 
                  primary={ui(item.text)}
                  sx={{ 
                    '& .MuiListItemText-primary': {
                      fontWeight: isSelected ? 'bold' : 'normal',
                      color: isSelected ? '#1976d2' : 'inherit'
                    }
                  }}
                />
              </ListItemButton>
            </ListItem>
          );
        })}
        </List>

        <Divider sx={{ mt: 2 }} />

        
      </Box>
    </Drawer>
  );
};

export default KULSSidebar;
